/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.NotificationSetting {
    angular.module("meevo.plugins.notificationSetting", []);
}